














import Vue from "vue";
import iwInputSelect from "@/shared/components/buildingBlocks/InputSelect.vue";

import { countries } from "@/shared/scripts/Countries";
import { mapGetters } from "vuex";
import { Trans } from "@/shared/scripts/helpers/translation/translation";

export default Vue.extend({
    components: {
        iwInputSelect: iwInputSelect
    },
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function() {
        return {
            pathInStore: "customer.location.address.provided.country",
        };
    },
    computed: {
        ...mapGetters({
            isReadonlyField: "FormModule/isReadonlyField"
        }),
        country: function(): string|null {
            return this.$store.getters["FormModule/getValueUI"](this.pathInStore);
        },
        options: function(): Array<Record<string, unknown>> {
            const mainCountriesWithoutUndefined = [...countries].splice(1);

            const countriesInternationalizationSupported = "DisplayNames" in Intl;

            let intlCountries: Intl.DisplayNames | null = null;
            if (countriesInternationalizationSupported) {
                intlCountries = new Intl.DisplayNames([Trans.currentLocale], { type: "region" });
            }

            const specialCountries: Record<string, Record<string, string>> = {

                // Belgium must always be translated
                BE: {
                    en: "Belgium",
                    fr: "Belgique",
                    nl: "België",
                },

                /**
                 * Not supported by the Intl API, though exists in our list and
                 * https://en.wikipedia.org/wiki/List_of_ISO_3166_country_codes
                 */
                EH: {
                    en: "Western Sahara",
                    fr: "Sahara occidental",
                    nl: "Westelijke Sahara",
                },
            };

            return mainCountriesWithoutUndefined
                .map(country => {
                    /**
                     * Hardcoded translation for Belgium (most of our clients)
                     * while we have to support older browsers.
                     * https://caniuse.com/?search=intl-displaynames-of
                     */
                    if (country.value == "BE" || country.value == "EH") {
                        return {
                            label: specialCountries[country.value][Trans.currentLocale],
                            value: country.value,
                        };
                    }
                    return {
                        label: (intlCountries?.of(country.value) ?? this.$t(country.label)) as string,
                        value: country.value,
                    };
                })
                .sort((a, b) => a.label.localeCompare(b.label, Trans.currentLocale));
        }
    },
    mounted: function() {
        if (this.$store.getters["FormModule/getValueUI"](this.pathInStore) === null) {
            this.$store.commit("FormModule/addValueUI", {path: this.pathInStore, value: "BE"});
        }
    },
    methods: {
        updateCountry: function (country: string) {
            if (this.country === null) {
                this.$store.commit("FormModule/deleteValueUI", this.pathInStore);
            } else {
                this.$store.commit("FormModule/addValueUI", {path: this.pathInStore, value: country});
            }
        }
    }

});
